<template>
  <v-dialog v-model="dialog" @click:outside="$emit('closeModal')" max-width="590">
      <v-card>
        <v-card-title class="headline pl-4">
           Veuillez sélectionner un client
        </v-card-title>

        <v-card-text>
          <v-combobox
            v-model="selectedClient"
            :items="clients"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="@id"
            label="Liste des clients"
            placeholder="Commencer à taper le nom d'un client pour rechercher ... "
            prepend-icon="mdi-database-search"
            return-object
          ></v-combobox>
        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-expand-transition>
          <div v-if="clients !== null">
            <p v-for="selectedClient in selectedClients" :key="selectedClient.id" class="pl-4"> Nom du client  : {{ selectedClient.name }}</p>
          </div>
        </v-expand-transition> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="orange darken-1" text @click="$emit('closeModal')">
            Annuler
          </v-btn>

          <v-btn color="blue darken-1" text @click="selectClient"> Valider </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

export default {

  data: () => ({
    isLoading: false,
    selectedClient: null,
    search: null,
  }),
  props: {
    clients: Array,
    dialog: Boolean,
  },
   computed: {
      apiUrl() {
        return process.env.VUE_APP_API;
      },
    },
  //  watch: {
  //     search(value) {
  //       // Items have already been requested
  //       if (this.isLoading) return;

  //       this.isLoading = true;

  //       // Lazily load input items
  //       Api.query("clients", { params: { name: value } })
  //         .then(clients => {
  //           this.clients = clients.data["hydra:member"];
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         })
  //         .finally(() => (this.isLoading = false));
  //     },
  //  },
  methods: {
    selectClient() {
      this.$emit("selectClient", this.selectedClient);
      this.selectedClient = null;
    },
  },
};
</script>
